import { wbFetch } from "./wbFetch";

type WbPublicatedGood = {
  nmID: number;
  imtID: number;
  nmUUID: string;
  subjectID: number;
  subjectName: string;
  vendorCode: string;
  brand: string;
  title: string;
  description: string;
  needKiz: boolean;
  dimensions: {
    width: number;
    height: number;
    length: number;
    weightBrutto: number;
    isValid: boolean;
  };
  photos: {
    big: string;
    c246x328: string;
    c516x688: string;
    hq: string;
    square: string;
    tm: string;
  }[];
  characteristics: {
    id: number;
    name: string;
    value: any;
  }[];
  sizes: {
    chrtID: number;
    techSize: string;
    wbSize: string;
    skus: string[];
  }[];
  createdAt: string;
  updatedAt: string;
};

interface GoodsRequestBody {
  settings: {
    cursor: {
      limit: number;
      updatedAt?: string;
      nmID?: number;
    };
    order: {
      ascending: boolean;
    };
    filter: {
      withPhoto: number;
    };
  };
}

export const getWbPublishedGoods = async (): Promise<WbPublicatedGood[]> => {
  const body: GoodsRequestBody = {
    settings: {
      cursor: {
        limit: 100,
      },
      order: {
        ascending: false,
      },
      filter: {
        withPhoto: -1,
      },
    },
  };

  let cards: WbPublicatedGood[] = [];

  while (true) {
    const response = await wbFetch(`https://content-api.wildberries.ru/content/v2/get/cards/list`, "POST", JSON.stringify(body));

    // console.log(response.cursor)

    // console.log(response.cards.length)

    // console.log(response);

    if (!response.cards) {
      break;
    }

    cards = cards.concat(response.cards);

    if (response.cursor?.total < body.settings.cursor?.limit) {
      break;
    }

    body.settings.cursor.updatedAt = response.cursor.updatedAt;
    body.settings.cursor.nmID = response.cursor.nmID;
  }

  return cards;
};
